import { DatePipe, JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { AlterationRequestPayload, DirectAlteration } from '../direct-alterations.service';

@Component({
  selector: 'sbnb-direct-alteration-review-and-confirm-list',
  templateUrl: './direct-alteration-review-and-confirm-list.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [JsonPipe, DatePipe],
})
export class DirectAlterationReviewAndConfirmListComponent {
  readonly alterationDetails = input.required<DirectAlteration>();
  readonly alterationRequest = input.required<AlterationRequestPayload>();
  readonly guestName = input<string>('the guest');

  readonly datesChanged = computed(() => {
    return (
      this.alterationRequest()?.start_date !== this.alterationDetails()?.previous_state.checkin ||
      this.alterationRequest()?.end_date !== this.alterationDetails()?.previous_state.checkout
    );
  });

  readonly adultsChanged = computed(() => {
    return this.alterationRequest()?.number_of_adults !== this.alterationDetails()?.previous_state.num_guests.adults;
  });

  readonly childrenChanged = computed(() => {
    return (
      this.alterationRequest()?.number_of_children !== this.alterationDetails()?.previous_state.num_guests.children
    );
  });

  readonly infantsChanged = computed(() => {
    return this.alterationRequest()?.number_of_infants !== this.alterationDetails()?.previous_state.num_guests.infants;
  });

  readonly petsChanged = computed(() => {
    return this.alterationRequest()?.number_of_pets !== this.alterationDetails()?.previous_state.num_guests.pets;
  });
}
